<ngb-accordion #acc="ngbAccordion" class="notary-accordion no-border" *ngIf="accordionData" activeIds="panel0">
  <ng-container *ngFor="let panel of accordionData; let i = index">
    <ngb-panel id="panel{{i}}">
      <ng-template ngbPanelTitle>
        <div ngbPanelToggle>
          <span class="align-middle">{{panel.properties.title}}&nbsp;</span>
          <span class="align-middle">
            <mat-icon aria-hidden="false" aria-label="Example home icon"  *ngIf="!acc.activeIds.includes('panel'+ i)">expand_more</mat-icon>
            <mat-icon aria-hidden="false" aria-label="Example home icon"  *ngIf="acc.activeIds.includes('panel'+ i)">expand_less</mat-icon>
          </span>           
      </div>
      </ng-template>
      <ng-template ngbPanelContent>
          <div class="col-xs-12 col-sm-12 col-md-12 multirow-table-wrapper">
            <app-info-table-multirow [tableData]="panel.completed"></app-info-table-multirow>
            <div *ngIf="(panel?.infoConfig?.role === 'NOTARY' || panel?.infoConfig?.displayAction === true)">
              <app-info-table-multirow [tableData]="panel.panelproperty"></app-info-table-multirow>
            </div>
            <div *ngIf="(panel?.infoConfig?.role === 'NOTARY' || panel?.infoConfig?.displayAction === true)">
              <app-info-table-multirow [tableData]="panel.partiesInvolved"></app-info-table-multirow>
            </div>
            <div *ngIf="(panel?.infoConfig?.role === 'NOTARY' || panel?.infoConfig?.displayAction === true)">
              <app-info-table-multirow [tableData]="panel.propertiesTable"></app-info-table-multirow>
            </div>
            <div *ngIf="(panel?.infoConfig?.role === 'NOTARY' || panel?.infoConfig?.displayAction === true)">
              <app-info-table-multirow [tableData]="panel.documentsTable"></app-info-table-multirow>
            </div>
            <div>
              <app-price-component
              [priceObject]="panel.priceObject" [fg]="applicationFormArray.at(i)"></app-price-component>
            </div>
          </div>
      </ng-template>
    </ngb-panel>

  </ng-container>
</ngb-accordion>
